var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sji-headers"},_vm._l((_vm.getHeaders),function(header){return _c('div',{key:header.value,staticClass:"sji-headers__element",class:{
    'sji-headers__element_name': header.value === 'name',
  },style:(`width: ${header.width}px`)},[_c('span',{staticClass:"sji-headers__text"},[_vm._v(" "+_vm._s(header.text)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }